import { z } from 'zod';
import { SemanticColorsSchema } from "../color/schema";
import { FontFamiliesSchema } from "../typography/schema";
export var WhiteLabeledThemeSchema = z.object({
  colors: SemanticColorsSchema,
  fontFamilies: FontFamiliesSchema
});